// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__hKJ9g","cell":"ColumnAccessor_cell__2Prgg","firstCellAccent":"ColumnAccessor_firstCellAccent__1AujE"};